import {addDataReducer} from "./reducer";


import  {combineReducers} from "redux";

const rootReducer = combineReducers({
    addDataReducer
})

export default rootReducer;